class MFRPlayPause {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {};

    this.init();
  }

  init() {
    this.$element.on("click", this.__handleButtonClick.bind(this));

    this.addJqueryFunction();
  }

  __handleButtonClick(e) {
    // alert('click')
    this.$element.toggleClass("play pause");
  }

  addJqueryFunction() {
    const self = this;
    if (!jQuery) return;
    jQuery.fn.extend({
      updateState: function (state) {
        if (!$(this).hasClass("play-pause-button")) {
          return $(this); // do nothing
        }
        self.$element.removeClass("play pause").addClass(state);

        return $(this);
      },
    });
  }
}

jQuery( () => {
  $(".play-pause-button").each( ( i, e ) => {
    const mfrPlayPause = new MFRPlayPause( i, e );
  } );
} );